import { Typography } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CloneScheduleOfEvent from "./clone.schedule.event.modal";
import EditScheduleOfEventModal from "./edit.schedule.event.modal";
import ViewScheduleOfEventModal from "./view.schedule.event.modal";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MuiTableRow from "@material-ui/core/TableRow";
import OptionsMenu from "./options.menu";
import TableCell from "@material-ui/core/TableCell";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { useScheduleEvents } from "../../../app/contexts/schedule.events.context";
import { useSnackbar } from "../../../app/contexts/snackbar.context";
import { otherStyles } from "../../../app/helpers/utils.js";
import { withStyles } from "@material-ui/core";
import { DeleteScheduleEventModal } from "./delete.schedule.event.modal/delete.schedule.event.modal.js";

const TableCellContent = ({ content, formatDate, noWrap, title }) => {
  // Handle missing values for protocol fields
  if (content === null || content === undefined) {
    return (
      <TableCell
        align="left"
        style={{ padding: 5 }}
      >
        <Typography
          noWrap={noWrap}
          title={title}
        >
          [n/a]
        </Typography>
      </TableCell>
    );
  }

  const parsedDate = moment.utc(content);
  const formattedDate = parsedDate.isValid()
    ? parsedDate.format("DD/MMM/YYYY")
    : "";

  return (
    <TableCell
      align="left"
      style={{ padding: 5 }}
    >
      <Typography
        noWrap={noWrap}
        title={title}
      >
        {formatDate ? formattedDate : content}
      </Typography>
    </TableCell>
  );
};

const TableRow = (props) => {
  const {
    isReadOnlyUser,
    soe,
    studyPlans,
    scheduleOfEventsId,
    scheduleOfEventsName,
    insertBy,
    updateDate,
    scheduleOfEventsDescr,
    scheduleOfEventsStatus,
    studyPlanId,
    scheduleOfEvents,
    savingSOEStudy,
    updateBy,
    insertDate,
    protocolDate,
    protocolVersion,
  } = props;

  const [editOpen, setEditOpen] = useState(false);
  const [cloneOpen, setCloneOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const classes = useStyles();
  const otherClasses = otherStyles();
  const [open, setOpen] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const { updateSOE, fetchSOEStudy } = useScheduleEvents();

  const { showSnackbar } = useSnackbar();

  const studyPlanName = useMemo(() => {
    if (!studyPlanId) return "";
    const filteredStudies = studyPlans.filter(
      (study) => study.studyPlanId === studyPlanId,
    );
    return filteredStudies.length > 0 ? filteredStudies[0].studyPlanName : "";
  }, [studyPlans, studyPlanId]);

  const navigate = useNavigate();
  const { id } = useParams();

  const redirect = async () => {
    await fetchSOEStudy(id);
  };

  const handleClick = (e) => {
    setAnchor(e.currentTarget);
    setOpen((prev) => !prev);
  };

  const StyledTableCell = withStyles((theme) => ({
    root: {
      paddingLeft: "5px",
      paddingRight: "5px",
      fontSize: "1rem",

      "&:first-child": {
        paddingLeft: "10px",
      },
    },
  }))(TableCell);

  const handleClickStudy = () => {
    navigate(`/ctpo/study-plans/${id}/soe/${scheduleOfEventsId}`);
  };

  const updateSOEHandler = async (soeValue) => {
    try {
      await updateSOE(soeValue, redirect);
      showSnackbar("Saved successfully", "success");
      setEditOpen((prev) => !prev);
    } catch (err) {
      console.log(err);
      showSnackbar("Failed to save soe", "error");
    }
  };

  if (!scheduleOfEventsId || !studyPlans) {
    return null;
  }

  const tableData = [
    { content: scheduleOfEventsDescr },
    { content: protocolVersion || null }, // Handle missing value
    { content: protocolDate || null, formatDate: "DD/MMM/YYYY" }, // Handle missing value
    { content: scheduleOfEventsStatus },
    { content: studyPlanName },
    { content: insertBy },
    { content: insertDate, formatDate: "DD/MMM/YYYY", noWrap: true },
    { content: updateBy },
    { content: updateDate, formatDate: "DD/MMM/YYYY", noWrap: true },
  ];

  return (
    <React.Fragment>
      <MuiTableRow>
        <StyledTableCell align="left"></StyledTableCell>
        <StyledTableCell
          className={otherClasses.link}
          onClick={handleClickStudy}
          align="left"
        >
          {scheduleOfEventsName}
        </StyledTableCell>

        {tableData.map((data, index) => (
          <TableCellContent
            key={index}
            content={data.content}
            formatDate={data.formatDate}
            noWrap={data.noWrap}
          />
        ))}

        <TableCell
          align="right"
          padding="checkbox"
        >
          <IconButton
            classes={classes}
            onClick={handleClick}
          >
            <MoreVertIcon classes={classes} />
          </IconButton>
          <OptionsMenu
            isReadOnlyUser={isReadOnlyUser}
            setEditOpen={setEditOpen}
            setCloneOpen={setCloneOpen}
            setDeleteOpen={setDeleteOpen}
            setViewOpen={setViewOpen}
            open={open}
            anchor={anchor}
            scheduleOfEventsId={scheduleOfEventsId}
            onClose={() => setOpen(false)}
          />
        </TableCell>
      </MuiTableRow>

      {viewOpen && (
        <ViewScheduleOfEventModal
          soe={soe}
          open={viewOpen}
          onClose={() => setViewOpen(false)}
        />
      )}
      {editOpen && (
        <EditScheduleOfEventModal
          soe={soe}
          open={editOpen}
          onClose={() => setEditOpen(false)}
          onContinue={updateSOEHandler}
        />
      )}
      {cloneOpen && (
        <CloneScheduleOfEvent
          open={cloneOpen}
          onClose={() => setCloneOpen(false)}
          soe={{ scheduleOfEventsName, scheduleOfEventsId, scheduleOfEvents }}
        />
      )}
      {deleteOpen && (
        <DeleteScheduleEventModal
          deleteOpen={deleteOpen}
          savingSOEStudy={savingSOEStudy}
          setDeleteOpen={setDeleteOpen}
          scheduleOfEventsId={scheduleOfEventsId}
          redirect={redirect}
          id={id}
        />
      )}
    </React.Fragment>
  );
};

export default TableRow;

const useStyles = makeStyles((theme) => ({
  root: {
    color: "var(--teal-700)",
    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
  },
}));
